(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('FacilitiesController', FacilitiesController);

  /** @ngInject */
  function FacilitiesController() {
  }
})();
